import React, { useEffect } from 'react';
import { useUpdate } from '@bydesign-ui/hooks';
import { useCascader } from '../../../hooks/cascader';
import { CascaderSelectPopoverPanel } from '../components/CascaderSelectPopoverPanel';
export function useCascaderSelectPopper(options) {
  var maxPopoverWidth = options.maxPopoverWidth,
      autoAlign = options.autoAlign,
      renderItem = options.renderItem,
      triggerId = options.triggerId,
      searchable = options.searchable,
      searchPlaceholder = options.searchPlaceholder,
      searchDebounceTime = options.searchDebounceTime,
      renderSearchItem = options.renderSearchItem,
      onSearchChange = options.onSearchChange,
      autoFocusSearch = options.autoFocusSearch,
      show = options.show,
      emptyRender = options.emptyRender,
      emptyContent = options.emptyContent;
  var cascader = useCascader();
  var update = useUpdate();
  var displayInfo = cascader.getDisplayInfo().map(function (item) {
    var id = item.id,
        label = item.label,
        disabled = item.disabled,
        readonly = item.readonly,
        search = item.search,
        data = item.item;

    var getAncestorSearchValue = function getAncestorSearchValue() {
      return search;
    };

    return {
      label: label,
      value: id,
      getAncestorSearchValue: getAncestorSearchValue,
      disabled: disabled,
      readonly: readonly,
      search: search,
      data: data
    };
  });
  useEffect(function () {
    cascader.addListener('value-change', update);
    return function () {
      cascader.removeListener('value-change', update);
    };
  }, []);

  var getPopover = function getPopover() {
    return React.createElement(CascaderSelectPopoverPanel, {
      show: show,
      autoAlign: autoAlign,
      maxPopoverWidth: maxPopoverWidth,
      renderItem: renderItem,
      triggerId: triggerId,
      searchable: searchable,
      searchPlaceholder: searchPlaceholder,
      searchDebounceTime: searchDebounceTime,
      renderSearchItem: renderSearchItem,
      onSearchChange: onSearchChange,
      autoFocusSearch: autoFocusSearch,
      emptyRender: emptyRender,
      emptyContent: emptyContent
    });
  };

  return {
    getPopover: getPopover,
    displayInfo: displayInfo
  };
}